import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_DARK = "/climateasy-logo.png?v=7";
export const LOGO_WHITE = "/climateasy-logo-white.png?v=7";
export const ICON_DARK = "/icon-dark.png?v=4";
export const ICON_WHITE = "/icon-white.png?v=4";
export const LOGO_URL = LOGO_DARK;
export const HERO_URL =
  "https://images.pexels.com/photos/5463575/pexels-photo-5463575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
export const TECH_URL =
  "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const ICE_URL =
  "https://images.unsplash.com/photo-1736843640242-f29cc14bb70e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGNsZWFuJTIwaWNlJTIwY3J5c3RhbCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzgyMDYyNTM3fDA&ixlib=rb-4.1.0&q=85";

const api = axios.create({ baseURL: API });

export const PHONE = "04 84 51 12 12";
export const PHONE_TEL = "+33484511212";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Une erreur est survenue";
}

export default api;
